module.exports = __webpack_public_path__ + "static/fonts/NanumSquareL.da1e0dd.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NanumSquare/NanumSquareL.eot
// module id = I4il
// module chunks = 1